angular.module('mandaeApp')
    .directive('updateTitle', function ($rootScope, $timeout) {
        return {
            link: function (scope, element) {
                var listener = function (event, toState) {

                    var title = 'Mandaê - O jeito mais fácil de enviar o que quiser';
                    if (toState.data && toState.data.pageTitle) {
                        title = toState.data.pageTitle;
                    }

                    $timeout(function () {
                        element.text(title);
                    }, 0, false);
                };

                $rootScope.$on('$stateChangeSuccess', listener);
            }
        };
    });
